/**
 * HTTP header used to correlate browser → API → logs / PostHog.
 * Keep in sync with apps/api CORS allow-headers and apps/web transport.
 */
export const CORRELATION_ID_HEADER = 'X-Correlation-Id' as const;
